import translate from './i18n';

export default {
  props: ['advertisementsData'],
  data() {
    return ({
      cities: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 15, 16, 18, 19, 20, 22,
        24, 55, 76, 140, 161, 200, 291, 297, 302, 418, 605, 17829, 17880],
    });
  },
  computed: {
    isVinnytsiaState() {
      const stateId = Number(this.advertisementsData?.location?.state?.id);

      return stateId === 1;
    },
    targetCities() {
      const citiId = Number(this.advertisementsData?.location?.city?.id);
      return this.cities.includes(citiId);
    },
  },
  i18n: {
    ...translate,
  },
};
